import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Typography, Grid, TextField } from "@mui/material";
import CommonDialog from "../../common/commonDialog";

const useStyles = makeStyles((theme) => ({
  checkLabelFont: {
    marginLeft: "12px!important",
    color: "#292929!important",
    fontSize: "1rem!important",
  },
  checkFont: {
    display: "flex",
    justifyContent: "start",
    marginLeft: "0px!important",
  },
}));

const PaymentTermsModal = (props) => {
  const classes = useStyles();

  const { open, onCancel, onSave, paymentTermsData, setPaymentTermsData } = props;

  // Safety check: ensure paymentTermsData is always defined
  const safePaymentTermsData = paymentTermsData || {
    paymentTermsId: null,
    name: "",
    code: "",
  };

  const onInputChange = (event) => {
    const { name, value } = event.target;
    const updatedData = { ...safePaymentTermsData, [name]: value };
    setPaymentTermsData(updatedData);
  };

  return (
    <CommonDialog
      onCancel={onCancel}
      onSave={onSave}
      open={open}
      primaryButtonLabel={"Save"}
      secondaryButtonLabel={"Cancel"}
      title={"Payment Terms"}
    >
      <Grid container spacing={2}>
    
        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Code"
            name="code"
            type="text"
            size="small"
            value={safePaymentTermsData.code || ""}
            onChange={onInputChange}
          />
        </Grid>

        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Name"
            name="name"
            multiline
            rows={2}
            value={safePaymentTermsData.name || ""}
            onChange={onInputChange}
          />
        </Grid>
 
      </Grid>
    </CommonDialog>
  );
};
export default PaymentTermsModal;
